/**
 * Enum definition for AccountStatus
 */
export var AccountStatus;
(function (AccountStatus) {
    AccountStatus["OPEN"] = "OPEN";
    AccountStatus["ACTIVE"] = "ACTIVE";
    AccountStatus["INACTIVE"] = "INACTIVE";
    AccountStatus["NOTFUNDED"] = "NOTFUNDED";
    AccountStatus["FUNDED"] = "FUNDED";
    AccountStatus["DORMANT"] = "DORMANT";
    AccountStatus["FROZEN"] = "FROZEN";
    AccountStatus["PAIDOFF"] = "PAIDOFF";
    AccountStatus["TERMINATED"] = "TERMINATED";
    AccountStatus["UNREDEEMED"] = "UNREDEEMED";
    AccountStatus["ABANDONED"] = "ABANDONED";
    AccountStatus["DELINQUENT"] = "DELINQUENT";
    AccountStatus["PENDING"] = "CLOSING";
    AccountStatus["CLOSED"] = "CLOSED";
    AccountStatus["CLOSING"] = "CLOSING";
    AccountStatus["ESCHEAT"] = "ESCHEAT";
    AccountStatus["MATURED"] = "MATURED";
    AccountStatus["AUTHORIZATION_BLOCKED"] = "AUTHORIZATION_BLOCKED";
    AccountStatus["BANKRUPT"] = "BANKRUPT";
    AccountStatus["CHARGED_OFF"] = "CHARGED_OFF";
    AccountStatus["FROZEN_OR_FRAUD"] = "FROZEN_OR_FRAUD";
    AccountStatus["INTEREST_FREE"] = "INTEREST_FREE";
    AccountStatus["LOST"] = "LOST";
    AccountStatus["NORMAL_STATUS"] = "NORMAL_STATUS";
    AccountStatus["REVOKED"] = "REVOKED";
    AccountStatus["STOLEN"] = "STOLEN";
})(AccountStatus || (AccountStatus = {}));
/**
 * Enum definition for AccountLOB
 */
export var AccountLOB;
(function (AccountLOB) {
    AccountLOB["DEPOSIT"] = "DEPOSIT";
    AccountLOB["INVEST"] = "INVEST";
    AccountLOB["WEALTH"] = "WEALTH";
    AccountLOB["HOMELOAN"] = "HOMELOAN";
    AccountLOB["AUTO"] = "AUTO";
    AccountLOB["MORTGAGE"] = "MORTGAGE";
    AccountLOB["CC"] = "CC";
})(AccountLOB || (AccountLOB = {}));
/**
 * Enum definition for AccountType
 */
export var AccountType;
(function (AccountType) {
    AccountType["CDA"] = "CDA";
    AccountType["CMG"] = "CMG";
    AccountType["DDA"] = "DDA";
    AccountType["MARGIN"] = "MARGIN";
    AccountType["MMA"] = "MMA";
    AccountType["SDA"] = "SDA";
    AccountType["TRUST"] = "TRUST";
    AccountType["INVA"] = "INVA";
    AccountType["INVS"] = "INVS";
    AccountType["INVW"] = "INVW";
    AccountType["MORTGAGE"] = "MORTGAGE";
    AccountType["HOME_EQUITY"] = "HOME_EQUITY";
    AccountType["LOAN"] = "LOAN";
    AccountType["OPERATING_LEASE"] = "OPERATING_LEASE";
    AccountType["FINANCE_LEASE"] = "FINANCE_LEASE";
    AccountType["HIRE_PURCHASE"] = "HIRE_PURCHASE";
    // START - CREDIT CARD
    AccountType["PLATINUM"] = "PLATINUM";
    AccountType["EVERYDAY"] = "EVERYDAY";
    AccountType["UNLIMITED"] = "UNLIMITED";
    // END - CREDIT CARD
})(AccountType || (AccountType = {}));
/**
 * Enum definition for Account STK Summary Type
 */
export var AccountStkSummaryType;
(function (AccountStkSummaryType) {
    AccountStkSummaryType["BUCKET"] = "BUCKET";
    AccountStkSummaryType["RUP"] = "RUP";
    AccountStkSummaryType["FAS"] = "FAS";
    AccountStkSummaryType["SIFI"] = "SIFI";
})(AccountStkSummaryType || (AccountStkSummaryType = {}));
/**
 * Enum definition for Account STK Summary Status
 */
export var AccountStkSummaryStatus;
(function (AccountStkSummaryStatus) {
    AccountStkSummaryStatus["ACTIVE"] = "ACTIVE";
    AccountStkSummaryStatus["SUSPENDED"] = "SUSPENDED";
    AccountStkSummaryStatus["PENDING"] = "PENDING";
})(AccountStkSummaryStatus || (AccountStkSummaryStatus = {}));
/**
 * Enum definition for Paperless Settings
 */
export var PaperlessSettings;
(function (PaperlessSettings) {
    PaperlessSettings["PAPER_STATEMENT"] = "PAPER_STATEMENT";
    PaperlessSettings["PAPERLESS"] = "PAPERLESS";
    PaperlessSettings["RETURNED_AND_NOT_ON_PAPERLESS"] = "RETURNED_AND_NOT_ON_PAPERLESS";
})(PaperlessSettings || (PaperlessSettings = {}));
/**
 * Enum definition for Product Sub Type
 */
export var ProductSubType;
(function (ProductSubType) {
    ProductSubType["ABAFFP"] = "ABAFFP";
    ProductSubType["ABATRAD"] = "ABATRAD";
    ProductSubType["ABC36FFP"] = "ABC36FFP";
    ProductSubType["ABC36TRAD"] = "ABC36TRAD";
    ProductSubType["ABC48FFP"] = "ABC48FFP";
    ProductSubType["ABC48TRAD"] = "ABC48TRAD";
    ProductSubType["ABC60FFP"] = "ABC60FFP";
    ProductSubType["ABC60TRAD"] = "ABC60TRAD";
    ProductSubType["COMTRAC"] = "COMTRAC";
    ProductSubType["CONGRESLSE"] = "CONGRESLSE";
    ProductSubType["EXPRESSFFP"] = "EXPRESSFFP";
    ProductSubType["EXPRSSTRAD"] = "EXPRSSTRAD";
    ProductSubType["LSERP"] = "LSERP";
    ProductSubType["MUNILSE"] = "MUNILSE";
    ProductSubType["RETAILFFP"] = "RETAILFFP";
    ProductSubType["RETAILTRAD"] = "RETAILTRAD";
    ProductSubType["SMARTLEASE"] = "SMARTLEASE";
    ProductSubType["SNGLPAYFFP"] = "SNGLPAYFFP";
    ProductSubType["SNGLPAYLSE"] = "SNGLPAYLSE";
    ProductSubType["SNGLPYTRAD"] = "SNGLPYTRAD";
    ProductSubType["SPIKEFFP"] = "SPIKEFFP";
    ProductSubType["SPIKETRAD"] = "SPIKETRAD";
    ProductSubType["SPLSERP"] = "SPLSERP";
})(ProductSubType || (ProductSubType = {}));
/**
 * Enum definition for Exclusions
 */
export var Exclusions;
(function (Exclusions) {
    Exclusions["Loss"] = "Loss";
    Exclusions["Quote"] = "Quote";
    Exclusions["Dashboard"] = "Dashboard";
    Exclusions["Payment"] = "Payment";
    Exclusions["DPAOnline"] = "DPAOnline";
})(Exclusions || (Exclusions = {}));
/**
 * Enum definition for Bankruptcy Codes
 */
export var BankruptcyCodes;
(function (BankruptcyCodes) {
    BankruptcyCodes["BK13"] = "BK13";
    BankruptcyCodes["BK13I"] = "BK13I";
    BankruptcyCodes["BK13O"] = "BK13O";
    BankruptcyCodes["BK13B"] = "BK13B";
    BankruptcyCodes["BK112"] = "BK112";
    BankruptcyCodes["BK12B"] = "BK12B";
    BankruptcyCodes["BK12I"] = "BK12I";
    BankruptcyCodes["BK12M"] = "BK12M";
    BankruptcyCodes["BKC7"] = "BKC7";
    BankruptcyCodes["CK7RF"] = "CK7RF";
    BankruptcyCodes["BKACO"] = "BKACO";
    BankruptcyCodes["BKIST"] = "BKIST";
    BankruptcyCodes["BLOS"] = "BLOS";
    BankruptcyCodes["BKNCP"] = "BKNCP";
    BankruptcyCodes["BKNON"] = "BKNON";
    BankruptcyCodes["BKP"] = "BKP";
    BankruptcyCodes["BKPP"] = "BKPP";
    BankruptcyCodes["BKPR"] = "BKPR";
    BankruptcyCodes["BKRCV"] = "BKRCV";
})(BankruptcyCodes || (BankruptcyCodes = {}));
/**
 * Enum definition for Car Garaged State
 */
export var CarGaragedState;
(function (CarGaragedState) {
    CarGaragedState["AL"] = "AL";
    CarGaragedState["AK"] = "AK";
    CarGaragedState["AZ"] = "AZ";
    CarGaragedState["AR"] = "AR";
    CarGaragedState["CA"] = "CA";
    CarGaragedState["CO"] = "CO";
    CarGaragedState["CT"] = "CT";
    CarGaragedState["DE"] = "DE";
    CarGaragedState["FL"] = "FL";
    CarGaragedState["GA"] = "GA";
    CarGaragedState["HI"] = "HI";
    CarGaragedState["ID"] = "ID";
    CarGaragedState["IL"] = "IL";
    CarGaragedState["IN"] = "IN";
    CarGaragedState["IA"] = "IA";
    CarGaragedState["KS"] = "KS";
    CarGaragedState["KY"] = "KY";
    CarGaragedState["LA"] = "LA";
    CarGaragedState["ME"] = "ME";
    CarGaragedState["MD"] = "MD";
    CarGaragedState["MA"] = "MA";
    CarGaragedState["MI"] = "MI";
    CarGaragedState["MN"] = "MN";
    CarGaragedState["MS"] = "MS";
    CarGaragedState["MO"] = "MO";
    CarGaragedState["MT"] = "MT";
    CarGaragedState["NE"] = "NE";
    CarGaragedState["NV"] = "NV";
    CarGaragedState["NH"] = "NH";
    CarGaragedState["NJ"] = "NJ";
    CarGaragedState["NM"] = "NM";
    CarGaragedState["NY"] = "NY";
    CarGaragedState["NC"] = "NC";
    CarGaragedState["ND"] = "ND";
    CarGaragedState["OH"] = "OH";
    CarGaragedState["OK"] = "OK";
    CarGaragedState["OR"] = "OR";
    CarGaragedState["PA"] = "PA";
    CarGaragedState["RI"] = "RI";
    CarGaragedState["SC"] = "SC";
    CarGaragedState["SD"] = "SD";
    CarGaragedState["TN"] = "TN";
    CarGaragedState["TX"] = "TX";
    CarGaragedState["UT"] = "UT";
    CarGaragedState["VT"] = "VT";
    CarGaragedState["VA"] = "VA";
    CarGaragedState["WA"] = "WA";
    CarGaragedState["WV"] = "WY";
    CarGaragedState["WI"] = "WI";
    CarGaragedState["WY"] = "WY";
})(CarGaragedState || (CarGaragedState = {}));
/**
 * Enum definition for Live Chat Alert Codes
 */
export var LiveChatAlertCodes;
(function (LiveChatAlertCodes) {
    LiveChatAlertCodes["BK13"] = "BK13";
    LiveChatAlertCodes["BK13I"] = "BK13I";
    LiveChatAlertCodes["BK13O"] = "BK13O";
    LiveChatAlertCodes["BK13B"] = "BK13B";
    LiveChatAlertCodes["BK112"] = "BK112";
    LiveChatAlertCodes["BK12B"] = "BK12B";
    LiveChatAlertCodes["BK12I"] = "BK12I";
    LiveChatAlertCodes["BK12M"] = "BK12M";
    LiveChatAlertCodes["BKA"] = "BKA";
    LiveChatAlertCodes["BKACO"] = "BKACO";
    LiveChatAlertCodes["BKC7"] = "BKC7";
    LiveChatAlertCodes["BKIST"] = "BKIST";
    LiveChatAlertCodes["BKNCP"] = "BKNCP";
    LiveChatAlertCodes["BKP"] = "BKP";
    LiveChatAlertCodes["BKPN"] = "BKPN";
    LiveChatAlertCodes["BKPP"] = "BKPP";
    LiveChatAlertCodes["BKPR"] = "BKPR";
    LiveChatAlertCodes["BKRCV"] = "BKRCV";
    LiveChatAlertCodes["CK7RF"] = "CK7RF";
    LiveChatAlertCodes["BLOS"] = "BLOS";
    LiveChatAlertCodes["CDE"] = "CDE";
    LiveChatAlertCodes["COLIN"] = "COLIN";
    LiveChatAlertCodes["CONFC"] = "CONFC";
    LiveChatAlertCodes["CONFI"] = "CONFI";
    LiveChatAlertCodes["DECEX"] = "DECEX";
    LiveChatAlertCodes["ICP"] = "ICP";
    LiveChatAlertCodes["IMPND"] = "IMPND";
    LiveChatAlertCodes["LGCPG"] = "LGCPG";
    LiveChatAlertCodes["LGCRQ"] = "LGCRQ";
    LiveChatAlertCodes["PFPEN"] = "PFPEN";
    LiveChatAlertCodes["RPVIP"] = "RPVIP";
    LiveChatAlertCodes["RPVRQ"] = "RPVRQ";
    LiveChatAlertCodes["SCRAD"] = "SCRAD";
    LiveChatAlertCodes["SCRAF"] = "SCRAF";
    LiveChatAlertCodes["SCRAM"] = "SCRAM";
    LiveChatAlertCodes["SCRAQ"] = "SCRAQ";
    LiveChatAlertCodes["SCRAS"] = "SCRAS";
    LiveChatAlertCodes["SCRM"] = "SCRM";
    LiveChatAlertCodes["SED"] = "SED";
    LiveChatAlertCodes["ARCRP"] = "ARCRP";
    LiveChatAlertCodes["ARCRR"] = "ARCRR";
    LiveChatAlertCodes["ATRC"] = "ATRC";
    LiveChatAlertCodes["ATRP"] = "ATRP";
    LiveChatAlertCodes["TNINS"] = "TNINS";
    LiveChatAlertCodes["TLWIO"] = "TLWIO";
    LiveChatAlertCodes["TLTWI"] = "TLTWI";
    LiveChatAlertCodes["TLNIO"] = "TLNIO";
    LiveChatAlertCodes["TTH"] = "TTH";
    LiveChatAlertCodes["TTLDF"] = "TTLDF";
    LiveChatAlertCodes["TWINS"] = "TWINS";
    LiveChatAlertCodes["MIG"] = "MIG";
})(LiveChatAlertCodes || (LiveChatAlertCodes = {}));
/**
 * Enum definition for Account Type Label
 */
export var AccountTypeLabel;
(function (AccountTypeLabel) {
    AccountTypeLabel["CHECKING"] = "CHECKING";
    AccountTypeLabel["SAVINGS"] = "SAVINGS";
    AccountTypeLabel["CDs"] = "CDs";
    AccountTypeLabel["AUTOMATED_INVESTING"] = "AUTOMATED INVESTING";
    AccountTypeLabel["SELF_DIRECTED"] = "SELF-DIRECTED";
    AccountTypeLabel["WEALTH_MANAGEMENT"] = "WEALTH MANAGEMENT";
    AccountTypeLabel["PERSONAL_ADVICE"] = "PERSONAL ADVICE";
    AccountTypeLabel["MORTGAGE"] = "MORTGAGE";
    AccountTypeLabel["HOME_EQUITY"] = "HOME EQUITY";
    // START - CREDIT CARD
    AccountTypeLabel["PLATINUM"] = "PLATINUM";
    AccountTypeLabel["EVERYDAY"] = "EVERYDAY";
    AccountTypeLabel["UNLIMITED"] = "UNLIMITED";
    // END - CREDIT CARD
    AccountTypeLabel["VEHICLE_FINANCING"] = "VEHICLE FINANCING";
})(AccountTypeLabel || (AccountTypeLabel = {}));
/**
 * Account Type To Label
 */
export const AccountTypeToLabel = {
    [AccountType.DDA]: AccountTypeLabel.CHECKING,
    [AccountType.MMA]: AccountTypeLabel.SAVINGS,
    [AccountType.SDA]: AccountTypeLabel.SAVINGS,
    [AccountType.CMG]: AccountTypeLabel.SAVINGS,
    [AccountType.CDA]: AccountTypeLabel.CDs,
    [AccountType.INVS]: AccountTypeLabel.SELF_DIRECTED,
    [AccountType.INVA]: AccountTypeLabel.AUTOMATED_INVESTING,
    [AccountType.INVW]: AccountTypeLabel.WEALTH_MANAGEMENT,
    [AccountType.MORTGAGE]: AccountTypeLabel.MORTGAGE,
    [AccountType.HOME_EQUITY]: AccountTypeLabel.HOME_EQUITY,
    [AccountType.PLATINUM]: AccountTypeLabel.PLATINUM,
    [AccountType.EVERYDAY]: AccountTypeLabel.EVERYDAY,
    [AccountType.UNLIMITED]: AccountTypeLabel.UNLIMITED,
    [AccountType.LOAN]: AccountTypeLabel.VEHICLE_FINANCING,
    [AccountType.OPERATING_LEASE]: AccountTypeLabel.VEHICLE_FINANCING,
    [AccountType.FINANCE_LEASE]: AccountTypeLabel.VEHICLE_FINANCING,
    [AccountType.HIRE_PURCHASE]: AccountTypeLabel.VEHICLE_FINANCING,
};
//# sourceMappingURL=data.js.map